<template>
  <Transition name="notice-slide">
    <div v-if="visible" class="security-notice">
      <div class="notice-header">
        <div class="notice-title">
          <span class="notice-icon">!</span>
          <span>{{ t('home.securityNotice.title') }}</span>
        </div>
        <button class="notice-close" @click="handleClose" :title="t('home.securityNotice.close')">
          <span>&times;</span>
        </button>
      </div>
      <div class="notice-body">
        <p>{{ t('home.securityNotice.content') }}</p>
      </div>
      
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLangStore } from '@/pinia/stores/lang'

const { t } = useI18n()
const langStore = useLangStore()

const visible = ref(false)

const checkAndShow = () => {
  visible.value = langStore.currentLang.startsWith('zh')
}

const handleClose = () => {
  visible.value = false
}

onMounted(() => {
  checkAndShow()
})

watch(() => langStore.currentLang, () => {
  checkAndShow()
})
</script>

<style scoped lang="scss">
.security-notice {
  position: fixed;
  bottom: 20px;
  left: 30px;
  width: 268px;
  height: 220px;
  background: rgba(189, 215, 238, 0.6);
  backdrop-filter: blur(12px) saturate(180%);
  border: 1px solid rgba(189, 215, 238, 0.6);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  z-index: 9999;
  overflow: hidden;
  font-family: 'AlibabaPuHuiTi', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
}

.notice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  background: linear-gradient(135deg, #336eb1, #70a4e0);
  color: #fff;
}

.notice-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
}

.notice-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.notice-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  transition: background 0.2s;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.35);
  }
}

.notice-body {
  padding:6px 16px;
  background: transparent;
  flex: 1;

  p {
    font-size: 13.5px;
    color: #333;
    line-height: 1.8;
    margin: 0;
  }
}

.notice-footer {
  padding: 12px 16px;
  background: rgba(189, 215, 238, 0.3);
  border-top: 1px solid rgba(189, 215, 238, 0.5);
  font-size: 13px;
  color: #555;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 0;

  span {
    margin-right: 4px;
  }

  .phone-info {
    margin-left: 12px;
  }

  a {
    color: #1890ff;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 动画 */
.notice-slide-enter-active,
.notice-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.notice-slide-enter-from,
.notice-slide-leave-to {
  opacity: 0;
  transform: translateX(-40px) scale(0.9);
}

/* 移动端适配 - 与 contact-container 风格一致 */
@media screen and (max-width: 768px) {
  .security-notice {
    bottom: 20px;
    left: 20px;
    right: 20px;
    width: auto;
    height: auto;
    background: #fff;
    backdrop-filter: none;
    border: none;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .notice-body {
    background: #fff;

    p {
      color: #333;
    }
  }

  .notice-footer {
    background: #f8f9fa;
    border-top: 1px solid #eee;
    border-radius: 0 0 16px 16px;
    color: #666;
  }
}

@media screen and (max-width: 480px) {
  .security-notice {
    bottom: 15px;
    left: 15px;
    right: 15px;
  }

  .notice-header {
    padding: 12px 14px;
  }

  .notice-title {
    font-size: 14px;
  }

  .notice-body {
    padding: 14px;

    p {
      font-size: 13px;
    }
  }
}
</style>
